import React, { useState } from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import HeaderNav from '../HeaderNav';
import LeftSidebar from '../LeftSidebar';
import BettorAIInterface from '../BettorAIInterface';
import BackButton from '../BackButton';

const BettorAIScreen = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const [sidebarOpen, setSidebarOpen] = useState(false);

    const handleSidebarToggle = () => {
        setSidebarOpen(!sidebarOpen);
    };

    const handleSidebarClose = () => {
        setSidebarOpen(false);
    };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', bgcolor: 'background.default' }}>
            {/* Header Navigation */}
            <HeaderNav onMenuToggle={handleSidebarToggle} />

            {/* Content Area with Sidebar */}
            <Box sx={{ display: 'flex', flexGrow: 1, minHeight: 0 }}>
                {/* Left Sidebar */}
                <LeftSidebar open={sidebarOpen} onClose={handleSidebarClose} />

                {/* Main Content Area */}
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        flexGrow: 1,
                        minWidth: 0,
                        // Add top margin to account for fixed header
                        mt: { xs: 7, sm: 8 }, // Adjust based on header height
                        // Add left margin for desktop sidebar (when not mobile)
                        ml: !isMobile ? 0 : 0, // LeftSidebar handles its own positioning
                    }}
                >
                    {/* BettorAI Interface Content */}
                    <Box
                        component="main"
                        sx={{
                            flexGrow: 1,
                            maxWidth: '1400px',
                            mx: 'auto',
                            width: '100%',
                        }}
                    >
                        <BackButton />
                        <BettorAIInterface />
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default BettorAIScreen;